import './swatch.css';

export default function Swatch({swatch}) {
    return (
        <div className="swatch" style={{backgroundColor: swatch }}></div>
    )
}